export const ACCOMPANYING_FIELD_PREFIX = 'accompanying_';
export const IS_ACCOMPANYING_FIELD_NAME = 'isAccompanying';